import * as SRD from 'mrblenny-storm-react-diagrams'
import CustomNodeWidget from './CustomNodeWidget'
import { CustomNodeModel } from './CustomNodeModel'
import * as React from 'react'

export class CustomNodeFactory extends SRD.AbstractNodeFactory {
  constructor(flow, nodeType) {
    super(nodeType)
    this.flow = flow // Pass in the flow at initialisation
  }

  generateReactWidget(diagramEngine, node) {
    return <CustomNodeWidget node={node} flow={this.flow} />
  }

  getNewInstance() {
    return new CustomNodeModel()
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/CustomNode/CustomNodeFactory.jsx